import { PAN, USER, ACCOUNT } from './steps';


export const MERCHANT_STATE = {
  PAN: {
    VERIFIED: {
      ...PAN.DETAILS.FILLED,
      pan_verification_status: PAN.STATUS.VERIFIED,
    }
  }
}

export const merchantDetailsMock = {
  merchants: [
    {
      ...USER,
      ...ACCOUNT,
      ...MERCHANT_STATE.PAN.VERIFIED,
      // test_mid: null,
      // business_type: "LongTail",
      // quality_score: null,
      // account_id: null,
      // business_entity_id: null,
      // business_category_id: null,
      // business_sub_category_id: null,
      // pancard_name: null,
      // pancard_number: null,
      // website_url: null,
      // android_url: null,
      // ios_url: null,
      // gst_number: null,
      // routing_mid: null,
      // average_delivery_time: null,
      // downjones_check: null,
      // aggregator_model: null,
      // aggregator_type: null,
      // monthly_expected_volume: null,
      // sap_id: null,
      // active:true,
      // website_approval_status: "Not Applicable",
      // sub_source: "WebsiteSignUp",
      // blocked:false,
      // website_remarks: null,
      // settlement_status: null,
      // source_details: null,
      // merchant_vertical: null,
      // notification_email: "test-bommu-243@yopmail.com",
      // bank_update_attempt_count:0,
      // partner_source: null,
      // flag:8,
      // integration_status: "Not Integrated",
      // merchant_type: null,
      // gmv_amount: null,
      // bank_update_attempt_left:11,
      // business_entity_uuid: null,
      // business_category_uuid: null,
      // business_sub_category_uuid: null,
      // next_bank_update_time: "2021-04-23T15:37:07.463+05:30",
      // business_pan_name_match:false,
      // admin_user_uuid: "11eb-a418-ee0cd40e-bea7-02f413145cce",
      // contact_details:[],
      // bank_detail: null,
      // operating_address: null,
      // registration_address: null,
      // website_detail: null,
      // attached_configs:[],
      // cs_plan: null
    }
  ]
}
